"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalTaskState = void 0;
var ExternalTaskState;
(function (ExternalTaskState) {
    ExternalTaskState["pending"] = "pending";
    ExternalTaskState["finished"] = "finished";
    ExternalTaskState["expired"] = "expired";
})(ExternalTaskState = exports.ExternalTaskState || (exports.ExternalTaskState = {}));
//# sourceMappingURL=ExternalTask.js.map